import {
	AffiliationDirection,
	AffiliationGroupSort
} from '@/core/graphql/generated/types';

export type HcoAffiliationSection = 'parent' | 'child' | 'partners';

export const PRTN_RELATIONSHIP_TYPE_ID = 'PRTN';
export const OWNSO_RELATIONSHIP_TYPE_ID = 'OWNSO';

type HcoAffiliationSectionConfig = {
	directions: AffiliationDirection[];
	relationshipTypeIds?: string[];
	excludeRelationshipTypeIds?: string[];
	modalSortBy: AffiliationGroupSort[];
	withTypeFilter: boolean;
};

export const HCO_AFFILIATION_SECTION_CONFIG: Record<
	HcoAffiliationSection,
	HcoAffiliationSectionConfig
> = {
	parent: {
		directions: [AffiliationDirection.Parent],
		excludeRelationshipTypeIds: [PRTN_RELATIONSHIP_TYPE_ID],
		modalSortBy: [AffiliationGroupSort.IsPrimary, AffiliationGroupSort.Name],
		withTypeFilter: false
	},
	child: {
		directions: [AffiliationDirection.Child],
		excludeRelationshipTypeIds: [PRTN_RELATIONSHIP_TYPE_ID],
		modalSortBy: [AffiliationGroupSort.Name],
		withTypeFilter: true
	},
	partners: {
		directions: [AffiliationDirection.Parent, AffiliationDirection.Child],
		relationshipTypeIds: [PRTN_RELATIONSHIP_TYPE_ID],
		modalSortBy: [AffiliationGroupSort.Name],
		withTypeFilter: true
	}
};
